import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { useSelector } from 'react-redux';
import { Data } from 'signup-constants/signupData/Data';
import { useSignupData } from '../signup-data/useSignupData';
import { getGuessedDataBiden, getGuessedDataBreeze } from '../store/guessed-prefill/selectors';
import { useACQ167Experiment } from '../hooks/useACQ167Experiment';
import { jsx as _jsx } from "react/jsx-runtime";
export const GuessedPrefillHelperText = ({
  dataKey
}) => {
  const {
    data
  } = useSignupData(dataKey);
  const guessedDataBiden = useSelector(getGuessedDataBiden(dataKey));
  const guessedDataBreeze = useSelector(getGuessedDataBreeze(dataKey));
  const {
    acq167HelpText,
    isAssignedToACQ167Variant_B
  } = useACQ167Experiment();
  if (!guessedDataBiden && !guessedDataBreeze) {
    return null;
  }
  let isGuessedDataInInput = guessedDataBiden === data;
  if (isAssignedToACQ167Variant_B && dataKey === Data.CompanyName) {
    isGuessedDataInInput = guessedDataBreeze === data;
  }
  if (isGuessedDataInInput && isValidI18nKey(acq167HelpText)) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: acq167HelpText
    });
  }
  return null;
};